@let agente = perfil();
<div
  class="flex min-h-screen items-center justify-center bg-gray-100 transition-colors duration-300 dark:bg-gray-950"
  style="
    background-image: url('assets/images/sistema/splash.jpeg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: cover;
  "
>
  <div
    class="relative w-full max-w-lg overflow-hidden rounded-3xl border border-gray-200 bg-white p-2 shadow-2xl transition-all duration-300 dark:border-slate-800 dark:bg-slate-900"
  >
    @if (agente) {
      <div
        class="absolute top-0 right-0 left-0 h-32 rounded-b-[2.5rem] bg-linear-to-r from-emerald-600 to-teal-700 shadow-md lg:h-44 dark:from-emerald-800 dark:to-teal-900"
      >
        <div
          class="absolute inset-0 bg-[radial-gradient(#fff_1px,transparent_1px)] bg-size-[16px_16px] opacity-10"
        ></div>
      </div>

      <div class="relative p-2 text-center">
        <div class="mb-4">
          <img
            [src]="
              'assets/images/sistema/logos/' +
              (temaService.isDarkMode() ? 'logo horizontal en blanco.png' : 'logo horizontal.png')
            "
            alt="Logo Agropecuario"
            class="mx-auto h-12 w-auto object-contain object-center lg:h-20"
          />
          <h1 class="mt-0.5 text-sm font-black tracking-wider text-white uppercase">
            Agente Censal
          </h1>
        </div>

        <div
          class="relative z-10 mx-auto h-32 w-32 overflow-hidden rounded-2xl border-4 border-white bg-gray-100 shadow-xl dark:border-slate-900 dark:bg-slate-800"
        >
          <div
            class="flex h-full w-full flex-col items-center justify-center bg-linear-to-br from-slate-100 to-slate-200 text-slate-800 dark:from-slate-800 dark:to-slate-700 dark:text-slate-200"
          >
            <span class="text-3xl font-extrabold tracking-tight">
              <!-- {{ agente.nombre.charAt(0) }}{{ agente.apellido_paterno.charAt(0) }} -->
              <!-- <mat-icon class="scale-350">{{
                agente.genero === 'Masculino' ? 'face' : 'face_3'
              }}</mat-icon> -->
              <mat-icon class="scale-350">person</mat-icon>
            </span>
          </div>

          <span
            class="absolute right-1 bottom-1 rounded-md px-2 py-0.5 text-[8px] font-bold tracking-wider uppercase shadow-sm"
          >
            {{ agente.genero }}
          </span>
        </div>

        <div class="my-2">
          <h2 class="text-xl font-bold tracking-tight text-slate-800 uppercase dark:text-white">
            {{ agente.nombre }} {{ agente.apellido_paterno }} {{ agente.apellido_materno }}
          </h2>
          <div
            class="mt-1.5 flex flex-col gap-3 rounded-xl border border-emerald-100 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700 dark:border-emerald-900/40 dark:bg-emerald-950/50 dark:text-emerald-300"
          >
            <span>{{ agente.nombre_cargo }}</span>
            <span class="">Brigada: {{ agente.codigo_brigada }}</span>
          </div>
        </div>
        <div class="flex items-center justify-center gap-1">
          <span
            class="rounded-2xl px-2 py-1 text-xl font-semibold text-slate-700 dark:text-slate-200"
            [class]="
              agente.estado === 'CONTRATADO'
                ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300'
                : 'bg-rose-100 text-rose-700 dark:bg-rose-900 dark:text-rose-400'
            "
          >
            Estado: {{ agente.estado === 'CONTRATADO' ? 'Activo' : 'Inactivo' }}
          </span>
        </div>

        <hr class="my-3 border-gray-100 dark:border-slate-800" />

        <div class="grid grid-cols-2 gap-x-2 gap-y-2 text-left text-xs">
          <div class="space-y-0.5">
            <span
              class="text-[10px] font-medium tracking-wider text-slate-400 uppercase dark:text-slate-500"
              >Documento de Identidad</span
            >
            <p class="font-bold text-slate-700 dark:text-slate-200">
              {{ agente.documento_identidad }}
              {{ agente.complemento_documento ? ' - ' + agente.complemento_documento : '' }}
              <span class="font-extrabold text-emerald-600 dark:text-emerald-400">{{
                agente.expedicion_documento
              }}</span>
            </p>
          </div>

          <div class="space-y-0.5">
            <span
              class="text-[10px] font-medium tracking-wider text-slate-400 uppercase dark:text-slate-500"
              >Contacto</span
            >
            <p class="font-semibold text-slate-700 dark:text-slate-200">
              {{ agente.telefono_celular }}
            </p>
          </div>

          <div class="col-span-2 space-y-0.5 sm:col-span-1">
            <span
              class="text-[10px] font-medium tracking-wider text-slate-400 uppercase dark:text-slate-500"
              >Departamento y Provincia</span
            >
            <p class="truncate font-semibold text-slate-700 dark:text-slate-200">
              {{ agente.departamento }} / {{ agente.provincia }}
            </p>
          </div>

          <div class="col-span-2 space-y-0.5 sm:col-span-1">
            <span
              class="text-[10px] font-medium tracking-wider text-slate-400 uppercase dark:text-slate-500"
              >Municipio y Comunidad</span
            >
            <p class="font-semibold text-slate-700 dark:text-slate-200">
              {{ agente.municipio }} - {{ agente.comunidad }}
            </p>
          </div>

          <div class="col-span-2 space-y-0.5">
            <span
              class="text-[10px] font-medium tracking-wider text-slate-400 uppercase dark:text-slate-500"
              >Dirección de Domicilio</span
            >
            <p
              class="truncate leading-relaxed font-medium text-slate-600 italic dark:text-slate-300"
            >
              {{ agente.direccion }}
            </p>
          </div>
        </div>

        <div
          class="flex flex-col items-center justify-center border border-dashed border-gray-200 dark:border-slate-800"
        >
          <span>Codigo de Tablet</span>
          <span class="mt-1 font-mono text-lg tracking-widest text-slate-400 dark:text-slate-500">
            {{ agente.tablet }}
          </span>
        </div>
      </div>
      <div class="my-1 flex flex-col items-center justify-center gap-2">
        <a matButton="filled" routerLink="/">
          <mat-icon>arrow_back</mat-icon>
          Volver al inicio
        </a>
      </div>
      <div
        class="flex items-center justify-between border-t border-gray-100 bg-slate-50 px-6 py-3 text-[10px] font-medium text-slate-400 dark:border-slate-800/80 dark:bg-slate-950/60 dark:text-slate-500"
      >
        <span
          >Valido del: {{ agente.fecha_inicio_contrato | date: 'dd/MM/yyyy' : 'utc' }} hasta

          @if (agente.fecha_rescision) {
            {{ agente.fecha_rescision | date: 'dd/MM/yyyy' : 'utc' }}
          } @else {
            {{ agente.fecha_fin_contrato | date: 'dd/MM/yyyy' : 'utc' }}
          }
        </span>
      </div>
    } @else {
      <div
        class="mx-auto mb-6 flex h-24 w-24 animate-pulse items-center justify-center rounded-full bg-rose-50 text-rose-500 dark:bg-rose-950/30 dark:text-rose-400"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-12 w-12"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm-1.215 5.97a3.58 3.58 0 0 1-1.285.23 3.58 3.58 0 0 1-1.285-.23A2.625 2.625 0 0 0 5.25 18h5.25a2.625 2.625 0 0 0-2.215-2.655Z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5"
            class="stroke-rose-600 stroke-2 dark:stroke-rose-400"
          />
        </svg>
      </div>

      <h3
        class="mb-2 text-center text-xl font-bold tracking-tight text-slate-800 uppercase dark:text-white"
      >
        Agente No Registrado
      </h3>

      <p class="mb-8 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
        No se encontró ninguna credencial activa vinculada al parámetro de búsqueda ingresado. Por
        favor, verifique el número de documento o intente nuevamente.
      </p>

      <div class="flex flex-col items-center justify-center gap-2">
        <a matButton="filled" routerLink="/">
          <mat-icon>arrow_back</mat-icon>
          Volver al inicio
        </a>
        <button (click)="cargarPerfilAgenteCensal()" matButton="outlined" class="mat-blue">
          <mat-icon>refresh</mat-icon>
          Reintentar búsqueda
        </button>
      </div>
    }
    <div class="my-2 flex flex-row justify-between p-1">
      <img src="assets/images/sistema/logos/escudo.png" class="h-16 w-16" alt="" />
      <img src="assets/images/sistema/logos/ine_90.png" class="h-16" alt="" />
    </div>
  </div>
</div>
